import { UserExerciseSession, UserWorkoutSession } from '../../entities';

export class Mapper {
  public static setupAllAfterDeserialize(allWorkouts: UserWorkoutSession[]) {
    allWorkouts.forEach((workout: UserWorkoutSession) => {
      Mapper.setupAfterDeserialize(workout, allWorkouts);
    });
  }

  public static setupAfterDeserialize(workout: UserWorkoutSession, allWorkouts: UserWorkoutSession[]) {
    workout.exerciseSessions = workout.exerciseSessions.map((session: UserExerciseSession) => {
      const newSession = UserExerciseSession.fromParentWorkoutSession(
        session.type, session.stationNumber, workout, session.workoutStage,
      );
      newSession.alternateExercise = session.alternateExercise;
      newSession.format = session.format;
      newSession.setSessionExercise(session.exercise);
      newSession.isPause = session.isPause;
      newSession.isWarmupOrWarmdown = session.isWarmupOrWarmdown;
      newSession.zone = session.zone;
      newSession.shouldUseAlternativeExercisesInStudio = session.shouldUseAlternativeExercisesInStudio;
      return newSession;
    });
    if (workout.pairedSessionReference !== undefined) {
      const matched = allWorkouts.filter((other: UserWorkoutSession) => {
        return other.pairedSessionReference === workout.uniqueReference &&
          workout.pairedSessionReference === other.uniqueReference;
      });
      workout.pairedSession = matched.length === 1 ? matched[0] : undefined;
    }
  }

  public static makeSerializable(workout: UserWorkoutSession) {
    workout.exerciseSessions = workout.exerciseSessions.map((session: UserExerciseSession) => {
      const newSession = new UserExerciseSession(session.type, session.stationNumber, undefined, session.workoutStage);
      newSession.format = session.format;
      newSession.alternateExercise = session.alternateExercise;
      newSession.setSessionExercise(session.exercise);
      newSession.isPause = session.isPause;
      newSession.isWarmupOrWarmdown = session.isWarmupOrWarmdown;
      newSession.zone = session.zone;
      newSession.shouldUseAlternativeExercisesInStudio = session.shouldUseAlternativeExercisesInStudio;
      return newSession;
    });
    workout.pairedSession = undefined;
  }
}
